import { useCallback } from 'react';
import { api } from '~/utils/api';

/**
 * Invalidate the scanner aggregate reads — Scan History counts, the dashboard's risk
 * trend chart, scoreboard, and high-risk list — after any action that changes feedback
 * statuses or document review state.
 *
 * These queries cache aggressively (5-minute client `staleTime` on top of a 5-minute
 * server-side memoization that writes bust via `clearScannerDashboardCache`), and
 * item-level feedback actions otherwise never touch them: after reviewers clear
 * feedback, the Scan History "Unresolved" chip and the dashboard charts would keep
 * showing pre-clear numbers for minutes.
 */
export default function useInvalidateScannerAggregates() {
  const utils = api.useUtils();

  return useCallback(async () => {
    await Promise.all([
      utils.scanner.getScanHistory.invalidate(),
      utils.scanner.getRiskCounts.invalidate(),
      utils.scanner.getFeedbackResolution.invalidate(),
      utils.scanner.getDocumentsReviewed.invalidate(),
      utils.scanner.getHighRiskIssues.invalidate(),
    ]);
  }, [utils]);
}
